var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5482 16.2741C32.5482 20.5902 30.8336 24.7296 27.7816 27.7816C24.7296 30.8336 20.5902 32.5482 16.2741 32.5482C11.9579 32.5482 7.81855 30.8336 4.76657 27.7816C1.71459 24.7296 6.51722e-07 20.5902 0 16.2741L16.2741 16.2741H32.5482Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9022 19.6512C24.5251 19.6512 25.0385 20.1589 24.9471 20.7751C24.6871 22.5285 23.8234 24.167 22.47 25.4331C20.8308 26.9665 18.6076 27.828 16.2894 27.828C13.9712 27.828 11.748 26.9665 10.1088 25.4331C8.75545 24.167 7.89172 22.5285 7.63167 20.7751C7.54029 20.1589 8.05371 19.6512 8.67659 19.6512L16.2894 19.6512H23.9022Z",
    fill: "url(#paint0_linear_1948_7678)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99494 30.8173C5.92489 29.6549 6.15738 27.8144 6.15738 27.0394L12.2602 27.33L13.7132 32.2704C12.7445 32.9485 10.4584 34.3628 9.06346 34.5953C7.31981 34.8859 4.12312 35.4671 3.25129 34.3046C2.37947 33.1422 3.83251 32.2704 4.99494 30.8173Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1948_7678",
    x1: 16.2894,
    y1: 19.6512,
    x2: 16.2894,
    y2: 27.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6E927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FBE00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/headerLogo.029281d95d58e23028c84c4304a1da23.svg";
export { ForwardRef as ReactComponent };